import type { ReleaseEntry } from './types';

/**
 * Bundled placeholder content used until the backend endpoint exists. Swap-out is automatic:
 * when `apiBase` is set, backend content replaces this. See DESIGN.md.
 */
export const DUMMY_ENTRIES: ReleaseEntry[] = [
  {
    id: 'rel-2026-06-24',
    title: 'Scheduled release windows',
    publishedAt: '2026-06-24T09:00:00.000Z',
    tags: ['New'],
    category: 'feature',
    html: `<p>Plan ahead — you can now <strong>schedule a release</strong> to publish at a future date and time, with per-environment windows.</p>
<ul><li>Pick a date, time and timezone</li><li>Stack multiple windows per environment</li><li>Cancel or reschedule any time before it fires</li></ul>`,
  },
  {
    id: 'rel-2026-06-12',
    title: 'Faster changelog search',
    publishedAt: '2026-06-12T13:30:00.000Z',
    tags: ['Improved'],
    category: 'improvement',
    html: `<p>Search across your entire history is now <strong>up to 5× faster</strong> and matches on tags and categories, not just titles.</p>`,
  },
  {
    id: 'rel-2026-05-30',
    title: 'Dark mode for the embedded widget',
    publishedAt: '2026-05-30T16:45:00.000Z',
    tags: ['New'],
    category: 'feature',
    html: `<p>The embedded widget now follows the host page's color scheme automatically, or you can pin it to light/dark from your dashboard.</p>`,
  },
  {
    id: 'rel-2026-05-18',
    title: 'Fixed: duplicate notifications on reconnect',
    publishedAt: '2026-05-18T08:15:00.000Z',
    tags: ['Fixed'],
    category: 'fix',
    html: `<p>Resolved an issue where reconnecting after a dropped connection could surface the same notification twice.</p>`,
  },
];
